<template>
  <div>
    <el-form :rules="rules" :model="registerForm" ref="registerForm" class="register-container" label-position="left" label-width="0px" v-loading="loading">
      <a href="https://www.hrbox.jp/"><img :src="require('@/assets/LOGO004.jpg')" style="width: 160px; height: 56px; padding-bottom: 20px;"/></a>
      <!-- <h3 class="register_title">{{$t("register.title")}}</h3> -->
      <el-form-item prop="username">
        <el-input type="text" v-model="registerForm.username" auto-complete="off" :placeholder="$t('register.username')" clearable></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="registerForm.password" auto-complete="off" :placeholder="$t('register.password')" show-password></el-input>
        <password-strength class="input-style666" v-model="registerForm.password" style="padding-top: 10px;"></password-strength>
      </el-form-item>
      <el-form-item prop="password2">
        <el-input type="password" v-model="registerForm.password2" auto-complete="off" :placeholder="$t('register.password2')" show-password></el-input>
      </el-form-item>
      <el-form-item prop="email">
        <el-input type="text" v-model="registerForm.email" auto-complete="off" :placeholder="$t('register.email')" clearable></el-input>
      </el-form-item>
      <el-form-item style="width: 100%">
        <el-button type="primary" @click="submitClick('registerForm')" style="width: 100%;" v-bind:disabled="registerForm.agree == false">{{$t("register.title")}}</el-button>
      </el-form-item>
      <el-form-item>
        　<el-checkbox v-model="registerForm.agree" size="mini"></el-checkbox> &nbsp; <el-button type="text" @click="handleAggrement()"> 利用規約 </el-button>を同意します。
      </el-form-item>
      <el-from-item>
        <el-button class="el-icon-caret-left" type="text" @click="jump('/registerSelect')">{{$t("register.return_registerSelect")}}</el-button>
      </el-from-item>
      <!-- <el-form-item>
      <el-link type="primary" disabled>{{$t("register.english")}}</el-link>&nbsp;&nbsp;&nbsp;&nbsp;
      <el-link type="primary" disabled>{{$t("register.japanese")}}</el-link>
    </el-form-item>-->
    </el-form>

    <!--利用規約-->
    <el-dialog :append-to-body="true" :visible.sync="dialogAggrement" width="58%">
      <el-form size="mini">
        <div>
          <p style="text-align: center; 
                    color: #2b2626;
                    font-size: 30px; 
                    font-weight: bold; 
                    font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif; 
                    margin-top: 0px;
                    margin-bottom: 0px;">
            HRBOX 利用規約</p>
          <hr class="styled_hr">
        </div>

        <div class="white_bg" ref="article01">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第1条（適用）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                本規約は、本サービスの提供条件及び本サービスの利用に関するお客様と当社との権利義務関係
                を定めることを目的とし、お客様と当社との間の本サービスに関する一切の関係に適用されます。
              </li>
              <li>
                本サービスに関して本規約とは別に契約又は規約等（以下「個別契約等」といいます。）が存在する場合、
                個別契約等も本規約の一部を構成するものとし、個別契約等の定めと本規約の定めが抵触するときは個別契
                約等の定めが優先するものとします。
              </li>
              <li>
                本規約の内容と本規約以外における本サービスの説明等とが異なる場合は、本規約の規定が優先して適用されるものとします。
              </li>
              <li>
                本規約のうち当社が本サービスの利用を許諾した時点ではお客様に適用されない規定がある場合、当該規定は、事情変更によって将来適用可能となった時点から適用されるものとします。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="gray_bg" ref="article02">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第2条（定義）</span>
              </div>
            </el-col>
            <el-col>
              <p style="width: 100%; padding-bottom: 0%; margin-bottom: 0%;"> &emsp;本規約において使用する用語の定義は以下の通りとします。</p>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                「お客様」とは、本規約の内容に承諾の上、当社所定の手続に従って本サービスの利用を申し込み、当社がその申込を承諾した法人及び団体並びに当社が本サービスのご利用を許諾した方をいいます。
              </li>
              <li>
                「当社ウェブサイト」とは、当社が運営するウェブサイトをいいます。
              </li>
              <li>
                「登録希望者」とは、本サービスの利用を希望し、登録の申込みを行い又は登録の申込みを行おうとする法人、団体又は個人を意味します。
              </li>
              <li>
                「登録データ」とは、お客様又はユーザーが本サービスを利用してアップロード等する情報（氏名、メールアドレス、会社情報、従業員情報、書類等の帳票出力に必要となる情報、その他のデータを含みますが、これらに限りません。）をいいます。
              </li>
              <li>
                「本サービス契約」とは、本規約に基づきお客様と当社との間で締結する、本サービスに関する利用契約をいいます。
              </li>
              <li>
                「ユーザー」とは、お客様により権限を与えられ、本サービスへのアクセス及び本サービスの利用を許可された者をいいます。
              </li>
              <li>
                「API連携サービス」とは、 本サービスに関して提供されるアプリケーション・プログラミング・インターフェース（以下「本API」といいます。）
                を通じて本サービスの機能又は本サービスから提供される情報を利用することにより、提供されるサービスをいいます。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="white_bg" ref="article03">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第3条（サービス内容）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                本サービスは、企業の人事労務業務の効率化及び最適化を目的とし、ソフトウェアにより提供されるサービスです。
                本サービスは、主として必要書類の帳票出力システムや人事情報管理システム等をWebブラウザ等を介して提供するものであり、
                当社が社会保険労務士法第2条に規定されている業務を代行することを目的としたものではありません。
              </li>
              <li>
                本サービスのより詳細な内容及び機能等は、当社ウェブサイト上の本サービスに関連するページをご参照ください。
                なお、当社は本サービスの内容又は機能等を、随時追加、変更又は削除等を行う場合があります。
              </li>
              <li>
                お客様は、法令を遵守した上で、かつ自己の責任において、本サービスを用いて個人番号（行政手続きにおける特定の個人を識別するための番号の利用等に関する法律で定める個人番号をいいます。）を含む個人情報を収集・保管・管理すること ができます。
                なお、当社は、個人番号データへの一切のアクセスを制限することとし、本サービスの提供に当たり、その電子データの取り扱いはいたしません。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="gray_bg" ref="article04">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第4条（登録）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                登録希望者は、当社が定める一定の情報（以下「登録事項」といいます。）を当社に提供することにより、本サービスの利用を申請することができます。なお、登録希望者は、当社ウェブサイト又は個別契約等において本規約を契約の内容とする旨を同意したときに、本規約の個別の条項についても同意したものとみなされます。
                また、当該申請を行った方は、当該申請により、登録希望者を代表して本サービス契約を締結する権限を有することを表明したものとします。
              </li>
              <li>
                当社は、前項の申請を受理した後、登録の可否を当社の基準に従って判断し、当社が登録を認める場合にはその旨を登録申請者に通知します。
                本サービスに関するお客様としての登録は、当社が当該通知を行ったことをもって完了したものとします。
              </li>
              <li>
                前項の登録の完了をもって、
                本規約の個別の条項において定めるとおりの本サービス契約がお客様と当社との間に成立し、お客様は本サービスを本規約に従い利用できるようになります。
              </li>
              <li>
                当社は、登録申請者が以下の各号のいずれかの事由に該当する場合は、登録及び再登録を拒否することがあります。
                また、その理由について当社は一切開示義務を負わないものとします。
                <ol class="ol_style">
                  <li>
                    当社に提供した登録事項の全部又は一部につき虚偽、誤記又は記載漏れがあった場合
                  </li>
                  <li>
                    本サービスと類似・競合するサービス若しくはウェブサイトを運営している又はその運営に協力していると当社が判断した場合
                  </li>
                  <li>
                    未成年者、成年被後見人、被保佐人又は被補助人のいずれかであり、法定代理人、後見人、保佐人又は補助人の同意等を得ていなかった場合
                  </li>
                  <li>
                    第22条（反社会的勢力の排除）第1項に定める暴力団員等又は同項第1号ないし第4号に該当する者であると当社が判断した場合
                  </li>
                  <li>
                    過去に当社との契約に違反した者又はその関係者であると当社が判断した場合
                  </li>
                  <li>
                    第12条（禁止事項）各号に掲げる行為を行ったことがあるか又は行うおそれがあると当社が判断した場合
                  </li>
                  <li>
                    第15条（当社による利用停止又は解除等）に定める措置を受けたことがある場合
                  </li>
                  <li>
                    その他、当社が登録を適当でないと判断した場合
                  </li>
                </ol>
              </li>
            </ol>
          </el-row>
        </div>

        <div class="white_bg" ref="article05">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第5条（登録事項の変更）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                お客様は、登録事項に変更があった場合、当社の定める方法により当該変更事項を遅滞なく当社に通知するものとします。
              </li>
              <li>
                当社は、お客様が前項の通知を怠ったことにより、お客様又は第三者が損害を被った場合であっても、一切責任を負わないものとします。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="gray_bg" ref="article06">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第6条（アカウント）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                当社は、登録希望者が登録を完了した場合、ユーザーID及びパスワード（以下「アカウント」といいます。）を発行します。
              </li>
              <li>
                お客様は、自己の責任において、本サービスに関するアカウントを適切に管理及び保管するものとし、
                自ら又はユーザーをして、これを第三者に利用させ、又は貸与、譲渡、名義変更、売買等をしてはならないものとします。
              </li>
              <li>
                アカウントの管理不十分、使用上の過誤、第三者の使用等によって生じた損害に関する責任はお客様が負うものとし、当社は一切の責任を負いません。
              </li>
              <li>
                当社は、アカウントの発行後に行われた当該アカウントによる本サービスの利用行為については、すべてお客様に帰属するものとみなします。
              </li>
              <li>
                当社は、当社の基準により、お客様のアカウントが不正使用されている可能性があると当社が判断した場合は、当該アカウントを停止することができます。その場合、お客様は当社が定める手続きに伴い、利用停止措置の解除手続きを行うこととします。
                なお、当社がこのような措置をとったことにより、お客様がアカウントを使用できないことを理由として損害が生じても、当社は一切の責任を負いません。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="white_bg" ref="article07">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第7条（利用料金）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                お客様が有料プラン（本サービスのうち利用料金に関する利用条件が定められた機能をいいます。）
                を利用する場合、お客様は、当社との間で別途合意する個別契約等に定める利用条件に従うものとします。
              </li>
              <li>
                第15条（当社による利用停止又は解除等）及び第16条（解約）に基づく解除又は解約があった場合であっても、当社は、利用料金の日割り計算及び払い戻しは行わないものとし、
                お客様は、解除又は解約日に関わらず契約期間分の利用料金を当社に支払うものとします。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="gray_bg" ref="article08">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第8条（個人情報の保護及び取扱いについての責任）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                当社は、お客様から開示を受けるデータ等に含まれる個人情報（本条において、かかる個人情報を「個人データ」
                といいます。なお、本規約において個人情報とは、個人情報の保護に関する法律（平成15年法律第57号。
                以下「個人情報保護法」といいます。）に定める個人情報をいいます。）については、お客様の委託に基づき提供を
                受けるものとします。お客様が個人データを本サービスにアップロードする等により当社に開示したときは、
                お客様は、本サービスの利用のために当社に個人データの取扱いを委託したものとします。
              </li>
              <li>
                お客様が当社に個人データの取り扱いを委託するに際しては、お客様自身が個人情報保護法等の法令に定める手続きを履践していることを保証するものとします。
              </li>
              <li>
                当社は、お客様から委託された個人データを当社が別途定めるプライバシーポリシー（以下「プライバシーポリシー」といいます。）に従い取り扱います。
              </li>
              <li>
                当社は、お客様から委託された個人データについて、委託の趣旨の範囲を超えて利用、加工、複写及び複製を行わないものとします。
              </li>
              <li>
                当社は、お客様から委託された個人データについて、漏えい、滅失又は毀損の防止その他の個人データの安全管理のため、管理責任者を定め、必要かつ適切な措置を講じます。
              </li>
              <li>
                当社は、お客様から委託された個人データについて、漏えい、滅失又は毀損等の事故が発生した場合、その事実を速やかにお客様に報告し、原因の調査を行い、事故の拡大防止に必要な措置を講ずるものとします。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="white_bg" ref="article09">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第9条（データの利用）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                当社は、前条の定めに関わらず、登録データその他のお客様及びユーザーに関するデータ（但し、個人データに該当するものを除きます。）を、本サービスを含む当社が提供し又は提供しようとしているサービスの品質向上、
                これらのサービスに関するお客様へのご案内、その他当社がプライバシーポリシーに定める目的で利用することができるものとします。
              </li>
              <li>
                当社は、統計的目的で本サービスの利用状況又はお客様及びユーザーの状況を分析し、統計結果を一般に公表することがあります。
                但し、個々のお客様及び特定の個人が識別されることのないようにいたします。
              </li>
              <li>
                当社は、お客様から本サービスの利用情報を取得し、又はお客様に対して本サービスに関するフィードバックの提供を求める場合があります。お客様は、これらの利用情報又はフィードバックの内容につき、本サービス契約期間中及び本サービス契約終了後において当社が利用することに同意するものとします。
                ただし、これらの利用情報又はフィードバックの内容の利用の目的は、本サービスの運営、改善、プロモーション及び新サービスの開発に限定されます。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="gray_bg" ref="article10">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第10条（委託）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <p class="ol_style" style="width: 100%;">
              &emsp;当社は、本サービスの提供に関して、業務の全部又は一部を、当社の責任において第三者に委託することがあります。
              ただし、その場合、当社は責任をもって委託先を管理するものとします。
            </p>
          </el-row>
        </div>

        <div class="white_bg" ref="article11">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第11条（権利帰属）</span>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <p class="ol_style" style="width: 100%; padding-bottom: 0%; margin-bottom: 0%;">
              &emsp;お客様は、本サービスの利用にあたり、自ら又はユーザーをして、以下の各号のいずれかに該当する行為又は該当すると当社が判断する行為をしてはなりません。
            </p>
          </el-row>

          <el-row>
            <ol class="ol_style">
              <li>
                本サービス及び当社ウェブサイトに関する知的財産権等その他一切の有体・無体の財産権は全て当社又は当社にライセンスを許諾している者に帰属しており、お客様に対して譲渡又は本規約に定める以上の使用許諾を行うものではありません。
              </li>
              <li>
                お客様は、登録データについて、自らがデータ登録又は送信することについての適法な権利を有していること、及び登録データが第三者の権利を侵害していないことについて、当社に対して表明し、保証するものとします。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="gray_bg" ref="article12">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第12条（禁止事項）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <p class="ol_style" style="width: 100%; padding-bottom: 0%; margin-bottom: 0%;">
              &emsp; お客様は、本サービスの利用にあたり、自ら又はユーザーをして、以下の各号のいずれかに該当する行為又は該当すると当社が判断する行為をしてはなりません。
            </p>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                法令に違反する行為又は犯罪行為に関連する行為
              </li>
              <li>
                当社、他のお客様若しくはユーザー又はその他の第三者に対する詐欺又は脅迫行為
              </li>
              <li>
                公序良俗に反する行為
              </li>
              <li>
                当社、他のお客様若しくはユーザー又はその他の第三者の著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権（それらの権利を取得し又はそれらの権利につき登録等を出願する権利を含み、以下「知的財産権等」と総称します。）、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為
              </li>
              <li>
                本サービスを通じ、以下に該当する情報又は該当すると当社が判断する情報を当社又は他のお客様若しくはユーザーに送信する行為

                <ul style="list-style: square;">
                  <li>
                    過度に暴力的又は残虐な表現を含む情報
                  </li>
                  <li>
                    コンピューターウィルスその他の有害なコンピュータープログラムを含む情報
                  </li>
                  <li>
                    当社、他のお客様若しくはユーザー又はその他の第三者の名誉又は信用を毀損する表現を含む情報
                  </li>
                  <li>
                    過度にわいせつな表現を含む情報
                  </li>
                  <li>
                    差別を助長する表現を含む情報
                  </li>
                  <li>
                    自殺、自傷行為を助長する表現を含む情報
                  </li>
                  <li>
                    薬物の不適切な利用を助長する表現を含む情報
                  </li>
                  <li>
                    反社会的な表現を含む情報
                  </li>
                  <li>
                    チェーンメール等の第三者への情報の拡散を求める情報
                  </li>
                  <li>
                    他人に不快感を与える表現を含む情報
                  </li>
                </ul>
              </li>
              <li>
                本サービスのネットワーク又はシステム等に過度な負担をかける行為
              </li>
              <li>
                本サービスの運営を妨害するおそれのある行為
              </li>
              <li>
                当社のネットワーク若しくはシステム等に不正にアクセスする行為、又は不正なアクセスを試みる行為
              </li>
              <li>
                逆コンパイル又は逆アセンブル等、当社のソフトウェア等を解析するための一切のリバースエンジニアリング行為
              </li>
              <li>
                第三者に成りすます行為
              </li>
              <li>
                同一の法人、団体又は人物が、その必要がないにも関わらず複数のお客様登録を行なう行為
              </li>
              <li>
                他のお客様又はユーザーのアカウントを利用する行為
              </li>
              <li>
                当社が事前に承諾しない本サービス上での宣伝、広告、勧誘又は営業行為
              </li>
              <li>
                本サービスの他の利用者の情報の収集行為
              </li>
              <li>
                当社、他のお客様若しくはユーザー又はその他の第三者に不利益、損害、不快感を与える行為
              </li>
              <li>
                反社会的勢力等への利益供与行為
              </li>
              <li>
                前各号の行為を直接又は間接に惹起し、又は容易にする行為
              </li>
              <li>
                その他、当社が不適切と判断する行為
              </li>

            </ol>
          </el-row>
        </div>

        <div class="white_bg" ref="article13">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第13条（本サービスの停止等）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                当社は以下のいずれかに該当する場合には、お客様に事前に通知することなく、本サービスの全部又は一部の提供を停止又は中断できるものとします。
                <ol class="ol_style">
                  <li>
                    本サービスに係るコンピューター・システムの点検又は保守作業を緊急に行う場合
                  </li>
                  <li>
                    コンピューター又は通信回線等が事故により停止した場合
                  </li>
                  <li>
                    本サービスの提供に必要な外部システム（Amazon Web Services等）の提供又は利用が遮断された場合
                  </li>
                  <li>
                    地震、落雷、火災、風水害、停電、疾病の蔓延、天災地変等の不可抗力により本サービスの運営ができなくなった場合
                  </li>
                  <li>
                    その他、当社が停止又は中断を必要と判断した場合
                  </li>
                </ol>
              </li>
              <li>
                当社は、本条に基づき当社が行った措置によって生じた損害について一切の責任を負いません。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="gray_bg" ref="article14">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第14条（本サービスの変更又は終了）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                当社は、当社の都合により、本サービスの内容の変更又は提供の終了ができるものとします。
                本サービスの提供を終了する場合、当社はお客様に対して終了予定日の6ヶ月前までに通知を行うものとします。
              </li>
              <li>
                当社は、本条に基づき当社が行った措置によって生じた損害について一切の責任を負いません。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="white_bg" ref="article15">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第15条（当社による利用停止又は解除等）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                当社は、お客様が以下の各号のいずれかの事由に該当する場合、事前の通知又は催告をすることなく、保存されているデータ（登録事項及び登録データを含みますが、これに限られません。）の削除、本サービス利用の一時的な停止、登録の抹消又は本サービス契約の解除を行うことができるものとします。
                <ol class="ol_style">
                  <li>
                    本規約のいずれかの条項に違反した場合
                  </li>
                  <li>
                    登録事項に虚偽の事実があることが判明した場合
                  </li>
                  <li>
                    当社からの問い合わせその他の回答を求める連絡に対して14日間以上応答がない場合
                  </li>
                  <li>
                    第4条（登録）第4項各号に該当する場合
                  </li>
                  <li>
                    支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合
                  </li>
                  <li>
                    その他、当社がお客様の本サービスの利用、登録又は本サービス契約の継続を適当でないと判断した場合
                  </li>
                </ol>
              </li>
              <li>
                前項各号のいずれかの事由に該当した場合、お客様は、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払いを行なわなければなりません。
              </li>
              <li>
                当社は、本条に基づき当社が行った行為によりお客様及びユーザーに生じた損害について一切の責任を負いません。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="gray_bg" ref="article16">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第16条（解約）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                お客様は、当社所定の方法で当社に通知することにより、本サービス契約を解約し、自己のお客様としての登録を抹消できます。
              </li>
              <li>
                解約後の個人情報の取り扱いについては、第8条（個人情報の保護及び取扱いについての責任）の規定に従うものとします。
              </li>
              <li>
                解約にあたりお客様が当社に対して債務を負っている場合、お客様は、当社に対する債務の一切について当然に期限の利益を失い、直ちに当社に対する債務の全てについて履行しなければなりません。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="white_bg" ref="article17">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第17条（連携サービス）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                お客様に対してAPI連携サービスが提供される場合、お客様は、自らの意思で当該サービスを利用し、当該サービスの利用により生ずるすべての結果について自ら責任を負うものとします。
                また、当社は、API連携サービスの利用によって生じるデータの変更、開示又は消去等について責任を負わないものとします。
              </li>
              <li>
                当社は、当社の都合により、本APIの内容の変更又は提供の終了ができるものとします。
                当社が本APIの提供を終了する場合、当社はお客様に事前に通知するものとします。
              </li>
              <li>
                当社は、本条に基づき当社が行った措置によって生じた損害について、一切の責任を負いません。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="gray_bg" ref="article18">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第18条（お客様の責任及び保証の制限）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                お客様は、本サービスをお客様が利用する為に必要な環境や設備（インターネット回線、パソコン等のハードウェア、Webブラウザ等のソフトウェア等を含みますがこれらに限りません。）
                を自己の責任と費用において適切に用意する必要があり、当社は、これらの用意に関する責任を負いません。
              </li>
              <li>
                当社は、本サービスがお客様の特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、お客様による本サービスの利用がお客様に適用のある法令又は業界団体の内部規則等に適合すること、登録データが正確であること、
                本サービスに関連して行った人事労務手続きにおいて不備が発生しないこと、及び不具合が生じないことについて、保証するものではありません。
              </li>
              <li>
                お客様が本サービスの機能を利用して他者との間の合意等の証跡を残す場合、お客様は、相手方が当該合意等の当事者本人であること及び当該合意等に関する権限を保有した者であることを自ら確認するものとします。
                当社は、かかる事項の確認又は立証を補助する機能又はサービスを提供することはありますが、かかる事項について保証するものではありません。
              </li>
              <li>
                当社は、本サービスからリンクされた第三者が運営するサイトに関して、いかなる保証もいたしません。
                また、当社は、リンク先で生じた損害や利用者同士のトラブル等に関して、いかなる補償及び関与をいたしません。
              </li>
              <li>
                お客様は、登録データについて、当社に保存責任・義務がないことを理解し、必要に応じてお客様自身でバックアップを取るものとします。
                当社は、登録データの消去、喪失等に関連してお客様が被った損害について、一切の責任を負いません。
              </li>
              <li>
                当社は、本サービスの利用不能若しくは本サービスの利用による機器の故障若しくは損傷によって生じた損害、又は第三者が当社ウェブサイト上で提供される情報を当社ウェブサイト以外のウェブサイト等に転載したことにより発生した損害、
                その他の第三者の行為に起因して生じた損害について、一切の責任を負いません。
              </li>
              <li>
                本サービス又は当社ウェブサイトに関連してお客様と他の利用者又は第三者との間において生じた取引、連絡若しくは紛争等について、当社は一切の責任を負いません。もしそれらに関連して当社に費用が発生した場合又は当社が賠償金の支払いを行なった場合には、お客様は当社に対して、
                当該費用（弁護士等の専門家の費用を含む）及び賠償金を補償するものとし、当社はお客様にこれらの合計額の支払いを請求できるものとします。
              </li>
            </ol>

          </el-row>
        </div>

        <div class="white_bg" ref="article19">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第19条（損害賠償）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                当社は、本規約の各条項に定める限度で本サービスについての責任を負うものとし、
                本規約において保証しない又は責任を負わないとしている事項及びお客様の責任としている事項については、責任を負わないものとします。
              </li>
              <li>
                前項のほか、何らかの理由により当社が責任を負う場合であっても、当社は、付随的損害、間接損害、特別損害、将来の損害及び逸失利益にかかる損害については、賠償する責任を負わないものとします。
                また、かかる場合において当社が負う損害賠償責任の額は、当社が本サービスに関してお客様から受領した直近12ヶ月分の利用料の総額を上限とします。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="gray_bg" ref="article20">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第20条（遅延損害金）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <p class="ol_style" style="width: 100%;">
              &emsp;お客様は、本サービス契約に基づく債務の弁済を怠った場合は、
              弁済すべき金額に対し、年14.6%の利率で計算した金額を遅延損害金として当社に支払うものとします。
            </p>
          </el-row>
        </div>

        <div class="white_bg" ref="article21">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第21条（秘密保持）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                お客様及び当社は、本規約に別段の定めがある場合を除き、本サービスに関連して相手方から開示を受けた情報であって、開示の際に秘密に取り扱うことを明示的に求められたものについて、相手方の事前の書面による承諾がある場合を除き、秘密情報として取り扱うものとします。
                但し、次の各号のいずれかに該当するものについては秘密情報には該当しないものとします。

                <ol class="ol_style">
                  <li>
                    開示を受けたときに既に保有していた情報
                  </li>
                  <li>
                    開示を受けた後、秘密保持義務を負うことなく第三者から正当に入手した情報
                  </li>
                  <li>
                    開示を受けた後、相手方から開示を受けた情報に関係なく独自に取得し、又は創出した情報
                  </li>
                  <li>
                    開示を受けたときに既に公知であった情報
                  </li>
                  <li>
                    開示を受けた後、自己の責めに帰し得ない事由により公知となった情報
                  </li>
                </ol>
              </li>
              <li>
                前項の規定にかかわらず、秘密情報を受領した当事者（以下「受領当事者」といいます。）は、監督官庁等の正当な要求若しくは法令の定めに従って開示する場合、受領当事者の役員・従業員、本サービスの委託先、弁護士若しくは会計士その他法律上機密保持義務を負う者へ開示する場合は、
                秘密情報を開示した当事者の事前の承諾を得ることなく秘密情報を開示することができるものとします。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="gray_bg" ref="article22">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第22条（反社会的勢力の排除）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                お客様及び当社は、相手方に対し、自己又は自己の役員若しくは自己の従業員が、現時点において、暴力団、暴力団員、暴力団員でなくなったときから5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動標榜ゴロ又は特殊知能暴力集団等、その他これらに準ずる者（以下これらを「暴力団員等」といいます。）
                に該当しないこと及び各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを確約するものとします。
                <ol class="ol_style">
                  <li>
                    暴力団員等が経営を支配している又は経営に実質的に関与していると認められる関係を有すること
                  </li>
                  <li>
                    自己又は第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってする等、不当に暴力団員等を利用していると認められる関係を有すること
                  </li>
                  <li>
                    暴力団員等に対して資金等を提供し、又は便宜を供与する等の関係を有すること
                  </li>
                  <li>
                    役員又は経営に実質的に関与している者が暴力団員等と社会的に非難されるべき関係を有すること
                  </li>
                </ol>
              </li>
              <li>
                お客様及び当社は、前項の表明及び確約に反して、相手方又は相手方の役員若しくは相手方の従業員が暴力団員等又は前項の各号のいずれかに該当することが判明したときは、
                何らの催告をせず、本サービス契約を解除することができるものとします。
              </li>
              <li>
                第15条（当社による利用停止又は解除等）第2項及び第3項の規定は、前項に基づき当社が本サービス契約を解除した場合に準用されるものとします。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="white_bg" ref="article23">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第23条（本規約等の変更）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                当社は、お客様の一般の利益に適合する場合、又は社会情勢、経済事情若しくは本サービスに関する実情の変化若しくは法令の変更その他合理的な事由があると認められる場合には、
                民法の定型約款の変更に係る規定に基づき、本サービスの目的に反しない範囲で本規約の内容を変更できるものとします。
              </li>
              <li>
                当社は、前項の定めに基づいて本規約の変更を行う場合は、変更後の利用規約の内容を、当社ウェブサイト上に表示し又は当社の定める方法によりお客様に通知することでお客様に周知するものとし、
                その周知の際に定める1ヶ月以上の相当な期間を経過した日から、変更後の利用規約が適用されるものとします。
              </li>
              <li>
                当社は、本条第1項の定めに基づかずに本規約の変更を行う場合は、変更後の利用規約の内容についてお客様の同意を得るものとします。この場合も、当社は、変更後の利用規約の内容を前項の定めに従って周知するものとします。なお、かかる周知の後、当該変更後の利用規約が適用される日までの間に、
                お客様が本サービスを利用した場合又は解約の手続をとらなかった場合には、お客様は当該変更後の利用規約の内容に同意したものとみなします。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="gray_bg" ref="article24">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第24条（連絡又は通知）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                お客様から当社に対する本サービスに関する問い合わせその他の連絡又は通知は、当社の定める方法で行うものとします。
              </li>
              <li>
                当社からお客様に対する本サービスに関する連絡又は通知は、登録事項に含まれるメールアドレスに電子メールを送る方法その他当社の定める方法によって行うものとします。
                当社が登録事項に含まれるメールアドレスその他の連絡先に対して連絡又は通知を行った場合、お客様は当該連絡又は通知を受領したものとみなします。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="white_bg" ref="article25">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第25条（利用契約上の地位の譲渡等）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_style">
              <li>
                お客様は、当社の書面による事前の承諾なく、本サービス契約上の地位又は本規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分はできません。
              </li>
              <li>
                当社は、本サービスにかかる事業を他社に譲渡した場合には、当該譲渡に伴い利用契約上の地位、本規約に基づく権利及び義務並びにお客様の登録事項その他の顧客情報を当該譲渡の譲受人に譲渡できるものとし、お客様は、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、
                通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。
              </li>
            </ol>
          </el-row>
        </div>

        <div class="gray_bg" ref="article26">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第26条（分離可能性）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <p class="ol_style" style="width: 100%;">
              &emsp; 本規約のいずれかの条項の全部又は一部が法令等により無効又は執行不能と判断された場合であっても、本規約における残りの条項、
              及び条項の一部が無効又は執行不能と判断された場合の当該条項の残りの部分は、継続して完全に効力を有するものとします。
            </p>
          </el-row>
        </div>

        <div class="white_bg" ref="article27">
          <el-row>
            <el-col :span="1">
              <div class="blue_minus">
                <i class="fa fa-window-minimize"></i>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="article_title">
                <span>第27条（準拠法及び管轄裁判所）</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <ol class="ol_class">
              <li>
                本規約及び本サービス契約の準拠法は、日本法とします。
              </li>
              <li>
                本規約又は本サービス契約に起因又は関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
              </li>
            </ol>
          </el-row>
        </div>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width: 120px" @click="cancel()" type="primary" size="medium">{{ $t("general.close") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postRequest } from "../utils/api";
import { putRequest } from "../utils/api";
import PasswordStrength from "@/components/Public/PasswordStrength";

export default {
  components: { PasswordStrength },
  data() {
    return {
      rules: {
        username: [
          {
            required: true,
            message: this.$t("register.usernameRule"),
            trigger: "blur",
          },
          {
            pattern: /^[A-Za-z0-9_]+$/,
            message: this.$t("register.usernamePattern"),
          },
        ],
        // email: [
        //   {
        //     required: true,
        //     message: this.$t("register.emailRule"),
        //     trigger: "blur",
        //   },
        //   {
        //     pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
        //     message: this.$t("register.emailPattern"),
        //   },
        // ],
        password: [
          {
            required: true,
            message: this.$t("register.passwordRule"),
            trigger: "blur",
          },
          {
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[])+$)([^(0-9a-zA-Z)]|[]|[a-zA-Z]|[0-9]){6,}$/,
            message: this.$t("register.passwordPattern"),
          },
        ],
        password2: [
          {
            required: true,
            message: this.$t("register.password2"),
            trigger: "blur",
          },
          {
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[])+$)([^(0-9a-zA-Z)]|[]|[a-zA-Z]|[0-9]){6,}$/,
            message: this.$t("register.passwordPattern"),
          },
        ],
      },
      dialogAggrement: false,
      checked: true,
      registerForm: {
        username: "",
        password: "",
        password2: "",
        email: "",
        agree: false,
      },
      plan: "",
      loading: false,
    };
  },
  methods: {
    jump(path) {
      this.$router.push(path);
      location.reload();
    },
    handleAggrement() {
      this.dialogAggrement = true;
    },
    cancel() {
      this.dialogAggrement = false;
    },
    submitClick(registerForm) {
      this.$refs[registerForm].validate((valid) => {
        if (valid) {
          var _this = this;
          this.loading = true;
          if (this.registerForm.password == this.registerForm.password2) {
            postRequest("/reg", {
              username: this.registerForm.username,
              password: this.registerForm.password,
              email: this.registerForm.email,
              plan: this.$route.query.plan,
            }).then(
              (resp) => {
                _this.loading = false;
                if (resp.status == 200) {
                  //成功
                  var json = resp.data;
                  if (json.status == "success") {
                    _this.$i18n.locale = json.locale;

                    _this.$alert(
                      this.$t("register.registerAlert"),
                      this.$t("register.success")
                    );

                    _this.$router.replace({ path: "/" });
                  } else if (json.status == "usernameError") {
                    _this.$alert(
                      this.$t("register.userAlert"),
                      this.$t("register.fail")
                    );
                  } else if (json.status == "emailError") {
                    _this.$alert(
                      this.$t("register.emailAlert"),
                      this.$t("register.fail")
                    );
                  }
                } else {
                  //失敗
                  _this.$alert(
                    this.$t("register.registerFail"),
                    this.$t("register.fail")
                  );
                }
              },
              (resp) => {
                _this.loading = false;
                _this.$alert(
                  this.$t("register.server_not_found"),
                  this.$t("register.fail")
                );
              }
            );
          } else {
            _this.loading = false;
            _this.$alert(
              this.$t("register.passwordFail"),
              this.$t("register.fail")
            );
          };
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
  },
  created() {
    var plan = this.$route.query.plan;
  },

};

</script>

<style scoped>
.gray_bg {
  border-bottom: 1px solid #e5e7eb;
  background-color: #fdfdfd;
  margin-left: 50px;
  margin-right: 50px;
}
.white_bg {
  border-bottom: 1px solid #e5e7eb;
  margin-left: 50px;
  margin-right: 50px;
}
.ol_style {
  text-align: left;
  padding-bottom: 25px;
  line-height: 26px;
  width: 90%;
  justify-content: flex-start;
}
.blue_minus {
  padding-top: 40px;
  text-align: left;
  color: #20a0ff;
}
.article_title {
  padding-top: 40px;
  text-align: left;
  font-weight: bold;
  font-size: 20px;
}
hr.styled_hr {
  margin-top: 0px;
  margin-bottom: 30px;
  padding-top: 0px;
  border: none;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgb(29, 118, 186),
    rgba(255, 255, 255, 0.083)
  );
  height: 4px;
  width: 70%;
}
.input-style666 {
  margin-left: 10px;
  margin-right: 0px;
  width: 390px;
}

.register-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 100px auto;
  width: 390px;
  height: 520px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}

.register_title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
  font-size: 30px;
}

.register_remember {
  margin: 0px 0px 35px 0px;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/Register.vue